import { FormEvent } from 'react';
import {
  FormErrors,
  IsFormValid,
  OnChangeFormInput,
  RunAllValidators,
  SetErrors,
  SetFormData,
  SetFormErrors,
} from 'src/hooks';

export enum FormInputNameCreditCard {
  number = 'number',
  date = 'date',
  cvv = 'cvv',
  name = 'name',
  document = 'document',
}

export enum FormInputNameCupom {
  name = 'name',
  code = 'code',
  amount = 'amount',
  discountType = 'discountType',
  discount = 'discount',
  amountSold = 'amountSold',
  status = 'status',
  date = 'date',
}
export interface UseFormControl {
  onChangeFormInput: OnChangeFormInput;
  formData: FormData;
  formErrors: FormErrors;
  setFormErrors?: SetFormErrors;
  setFormData?: SetFormData;
  isFormValid?: IsFormValid;
  runAllValidators?: RunAllValidators;
  setErrors?: SetErrors;
  resetForm?: () => void;
  onSubmit?: (e: FormEvent) => void;
}
